import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

/* Layout */

/**
 * Note: 路由配置项
 *
 * hidden: true                   // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true               // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect           // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'             // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * meta : {
    noCache: true                // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'               // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'             // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false            // 如果设置为false，则不会在breadcrumb面包屑中显示
  }
 */

// 公共路由
export const constantRoutes = [
  {
    path: '*',
    component: () => import('@/views/error/404.vue'),
    hidden: true
  },
  {
    path: '/',
    component: () => import('@/views/index/index.vue'),
    hidden: true,
    meta: {
      title: '银保镖，一站式电子保函服务平台'
    }
  },
  {
    path: '/index',
    component: () => import('@/views/index/index.vue'),
    hidden: true,
    meta: {
      title: '银保镖，一站式电子保函服务平台'
    }
  },
  {
    path: '/about',
    component: () => import('@/views/about/index.vue'),
    hidden: true,
    meta: {
      title: '关于我们'
    }
  },
  {
    path: '/contact',
    component: () => import('@/views/contact/index.vue'),
    hidden: true,
    meta: {
      title: '联系我们'
    }
  },
  {
    path: '/applyFor',
    component: () => import('@/views/applyFor/begin.vue'),
    hidden: true,
    meta: {
      title: '保函申请'
    }
  },
  {
    path: '/applyForMore',
    component: () => import('@/views/applyForMore/begin.vue'),
    hidden: true,
    meta: {
      title: '保函申请'
    }
  },
  {
    path: '/signUpload',
    component: () => import('@/views/applyForMore/signUpload.vue'),
    hidden: true,
    meta: {
      title: '保函详情'
    }
  },
  {
    path: '/applyDetail',
    component: () => import('@/views/applyForMore/detail.vue'),
    hidden: true,
    meta: {
      title: '保函详情'
    }
  },

  {
    path: '/applyForPay',
    component: () => import('@/views/applyFor/payment.vue'),
    hidden: true,
    meta: {
      title: '保函详情'
    }
  },
  {
    path: '/applyForOver',
    component: () => import('@/views/applyFor/over.vue'),
    hidden: true,
    meta: {
      title: '保函详情'
    }
  },
  {
    path: '/userAgreement',
    component: () => import('@/views/userAgreement/index.vue'),
    hidden: true,
    meta: {
      title: '保函代办理线上申请协议'
    }
  },
  {
    path: '/privacyAgreement',
    component: () => import('@/views/privacyAgreement/index.vue'),
    hidden: true,
    meta: {
      title: '线上保函协议'
    }
  },
  {
    path: '/adminHead',
    component: () => import('@/components/adminHead/index.vue'),
    hidden: true,
    children: [
      {
        path: '/indexAdmin',
        name: 'indexAdmin',
        component: () => import('@/views/indexAdmin/index.vue'),
        meta: {
          title: '网站首页'
        }
      },
      {
        path: '/bidBondAdmin',
        name: 'bidBondAdmin',
        component: () => import('@/views/bidBondAdmin/index.vue'),
        meta: {
          title: '保函列表'
        }
      },
      {
        path: '/contractAdmin',
        name: 'contractAdmin',
        component: () => import('@/views/contractAdmin/index.vue'),
        meta: {
          title: '履约、预付保函'
        }
      },
      {
        path: '/titleAdmin',
        name: 'titleAdmin',
        component: () => import('@/views/titleAdmin/index.vue'),
        meta: {
          title: '抬头管理'
        }
      },
      {
        path: '/titleAdd',
        name: 'titleAdd',
        component: () => import('@/views/titleAdd/index.vue'),
        meta: {
          title: '新增/编辑抬头'
        }
      },
      {
        path: '/invoiceAdmin',
        name: 'invoiceAdmin',
        component: () => import('@/views/invoiceAdmin/index.vue'),
        meta: {
          title: '申请发票'
        }
      },
      {
        path: '/invoiceAdd',
        name: 'invoiceAdd',
        component: () => import('@/views/invoiceAdd/index.vue'),
        meta: {
          title: '申请发票'
        }
      },
      {
        path: '/enterpriseMsgAdmin',
        name: 'enterpriseMsgAdmin',
        component: () => import('@/views/enterpriseMsgAdmin/index.vue'),
        meta: {
          title: '企业信息'
        }
      },
      {
        path: '/etpLegaMsgAdmin',
        name: 'etpLegaMsgAdmin',
        component: () => import('@/views/etpLegaMsgAdmin/index.vue'),
        meta: {
          title: '法人信息'
        }
      },
      {
        path: '/idMsgAdmin',
        name: 'idMsgAdmin',
        component: () => import('@/views/idMsgAdmin/index.vue'),
        meta: {
          title: '账号信息'
        }
      }
    ]
  },
  {
    path: '/setup-channel',
    name: 'setup-channel',
    component: () => import('@/views/setup-channel/index.vue'),
    meta: {
      title: '渠道管理'
    }
  }
]

export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
